[
  { "norad": 39084, "name": "Landsat 8" },
  { "norad": 49260, "name": "Landsat 9" },
  { "norad": 39634, "name": "Sentinel-1A" },
  { "norad": 62000, "name": "Sentinel-1C" },
  { "norad": 40697, "name": "Sentinel-2A" },
  { "norad": 42063, "name": "Sentinel-2B" },
  { "norad": 41335, "name": "Sentinel-3A" },
  { "norad": 43437, "name": "Sentinel-3B" },
  { "norad": 42969, "name": "Sentinel-5P" }
]
